import React from 'react';

type BoardIconProps = {
  width?: string;
  height?: string;
  color?: string;
};

function BoardIcon({
  width = '20',
  height = '20',
  color = 'black',
}: BoardIconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M7.49935 14.1328L3.33268 18.2995M12.4993 14.1328L16.666 18.2995M9.99935 1.63281V3.29948M9.99935 18.2995V14.1328M4.33268 14.1328H15.666C16.5994 14.1328 17.0661 14.1328 17.4227 13.9512C17.7363 13.7914 17.9912 13.5364 18.151 13.2228C18.3327 12.8663 18.3327 12.3996 18.3327 11.4661V5.96615C18.3327 5.03272 18.3327 4.56601 18.151 4.2095C17.9912 3.89589 17.7363 3.64092 17.4227 3.48114C17.0661 3.29948 16.5994 3.29948 15.666 3.29948H4.33268C3.39926 3.29948 2.93255 3.29948 2.57603 3.48114C2.26243 3.64092 2.00746 3.89589 1.84767 4.2095C1.66602 4.56601 1.66602 5.03273 1.66602 5.96615V11.4661C1.66602 12.3996 1.66602 12.8663 1.84767 13.2228C2.00746 13.5364 2.26243 13.7914 2.57603 13.9512C2.93255 14.1328 3.39926 14.1328 4.33268 14.1328Z'
        stroke={color}
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default BoardIcon;
